import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex md:flex-row flex-col items-center md:space-x-3 md:space-y-0 space-y-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Save Changes", -1)
const _hoisted_3 = { class: "mt-6 md:text-2xl text-lg font-medium text-neutral-600" }
const _hoisted_4 = { class: "md:inline-block block font-semibold text-neutral-900" }
const _hoisted_5 = { class: "w-full lg:p-6 p-4 mx-auto my-6 border border-gray-200 rounded" }
const _hoisted_6 = { class: "flex items-center justify-between" }
const _hoisted_7 = {
  key: 0,
  class: "grid grid-cols-6 md:gap-6 gap-3 mt-6"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_9 = { class: "md:col-span-3 col-span-6" }
const _hoisted_10 = { class: "md:col-span-3 col-span-6" }
const _hoisted_11 = { class: "md:col-span-2 col-span-6" }
const _hoisted_12 = { class: "md:col-span-2 col-span-6" }
const _hoisted_13 = { class: "md:col-span-2 col-span-6" }
const _hoisted_14 = { class: "col-span-6" }
const _hoisted_15 = { class: "col-span-6" }
const _hoisted_16 = { class: "grid grid-cols-6 col-span-6 gap-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Safety Factor")
], -1)
const _hoisted_18 = { class: "md:col-span-3 col-span-6" }
const _hoisted_19 = { class: "text-xs font-medium text-neutral-600" }
const _hoisted_20 = { class: "md:col-span-3 col-span-6 md:mt-0 -mt-3" }
const _hoisted_21 = { class: "flex items-center space-x-6" }
const _hoisted_22 = { class: "col-span-6" }
const _hoisted_23 = { class: "col-span-6" }
const _hoisted_24 = { class: "col-span-6" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Safety Decision Plan")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Risk Codes")
], -1)
const _hoisted_27 = { class: "md:col-span-2 col-span-6" }
const _hoisted_28 = { class: "md:col-span-2 col-span-6" }
const _hoisted_29 = { class: "md:col-span-2 col-span-6" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-span-6",
  id: "risk_code_id"
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm font-bold" }, "Safety Decisions:")
], -1)
const _hoisted_31 = {
  for: "action_plan-1",
  class: "relative flex items-center h-full py-3 pr-3 pl-3 border rounded cursor-pointer border-neutral-100 min-h-[98px]"
}
const _hoisted_32 = { class: "text-xs font-medium text-neutral-600" }
const _hoisted_33 = { class: "col-span-6" }
const _hoisted_34 = { class: "col-span-6" }

import { ref, onMounted, computed, watch } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { useRouter, useRoute } from "vue-router"; 
import { renderSelect, renderSelectV2 } from "@/interfaces/DropdownInterface"; 
import { errorResponse } from "@/helpers/errorMessage";
import { SafetyAssessmentStatus } from "@/views/enums/SafetyAssessmentStatus"; 
import CkEditor from '@/components/inputs/CKEditor.vue';
import pickBy from "lodash/pickBy"; 
import FormOptions from "@/classes/Forms/FormOptions";  
import { onIonViewWillEnter } from "@ionic/vue"; 

/******************************** For Offline Imports ***************************** */
import CaseImmediateService from "@/classes/Cases/CaseImmediateAssessment/CaseImmediateService";
import CaseSafetyAssessmentForm from "@/classes/Cases/CaseImmediateAssessment/Formatters/CaseSafetyAssessmentForm"; 
import { useNetworkStore } from "@/store/network";
import Rules from "@/classes/Cases/CaseImmediateAssessment/Validation/Rules";
import ErrorValidation from "@/views/interventions/Components/Classess/ErrorValidation";
import useVuelidate from "@vuelidate/core";
import AssessmentOfflineProcessor from "@/classes/Cases/CaseImmediateAssessment/Processor/OfflineProcessor";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatePage',
  setup(__props) {

const { createRules } = Rules;
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
/********************************************************************************** */
/********************************************************************************** */

const router = useRouter();
const route = useRoute();
const loaded = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const assessmentId = ref<number | null>(route.params.assessment);
const questions = ref<renderSelect[]>([]);
const riskCodes = ref<renderSelect[]>([]);
const safetyFactorOptions = ref<any>([]);
const form = ref<any>(CaseSafetyAssessmentForm.createForm({}));
const errors = ref<object>({});
const successMessage = ref<string>("Safety Assessment has been updated!");
const offlineParams = ref<string>(route.query.offline); 

//validation
const validateForm = () => {
	const vuelidate = useVuelidate(createRules({...form.value}), form.value)
	const result = vuelidate.value.$validate();
	result
		.then((res) => {
			if(res) { 
				save()
			} else {
				errors.value = ErrorValidation.getErrors(vuelidate.value)
                errorResponse(errors.value);
			}
		})
}
const save = (): void => {
	errors.value = {};
	if(assessmentId.value){
		CaseImmediateService.update(
		patientId.value,
		caseId.value,
		assessmentId.value,
		isNetworkAvailable.value,
		{ ...form.value, ...{ isOfflineData: offlineParams.value } },
	)
		.then(async (response: object) => {
            await getData();
			showSuccess.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: object) => {
			errors.value = errorResponse(error.response?.data?.errors);
		});
	}else{
		CaseImmediateService.store(
		patientId.value,
		caseId.value, 
		isNetworkAvailable.value,
		{ ...form.value, ...{ isOfflineData: offlineParams.value } },
	)
		.then(async (response: object) => {
            await getData(response.data.data.id);
			showSuccess.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: object) => {
			errors.value = errorResponse(error.response?.data?.errors);
		});
	}
	
};

const redirectSuccess = async (): void => {
	router.replace(`/patient/${patientId.value}/cases/${caseId.value}/edit`);
	showSuccess.value = false;
};

const template = (items: any): void => {
	form.value.questions = questions.value.map((item: any) => {
		const newForm = items?.filter((question: any) => {
			if (question.question_id == item.id) {
				return {
					question_id: question.question_id,
					supporting_information: question.supporting_information || "",
					status: question.status,
				};
			}
		});
		return newForm.length > 0
			? newForm[0]
			: { question_id: item.id, supporting_information: null, status: SafetyAssessmentStatus.UNKNOWN };
	});
};

const renderCount = (data: [], type: number): number => { 
	return data.filter((item: object) => {
		if (item.status == type) {
			return item;
		}
	}).length;
};

const maxDate = () => {
	return new Date().toISOString().split("T")[0];
};

const date = ref(new Date());

// const checkIfAssessmentIsCreated = async () => { 	
//     if (assessmentId.value && !isNetworkAvailable.value) {
// 		const response = await CaseImmediateService.checIfCreated(assessmentId.value || 0);  
//         if (response.length > 0) {
//             // router.push(`/patient/${patientId.value}/cases/${caseId.value}/safety-assessment/${response[0].id}/view`);
//         }
//     }
// }

const getData = async (id= null): void => { 
    const setId = id || assessmentId.value;
	if (setId) { 
		await CaseImmediateService.edit(
			patientId.value,
			caseId.value,
			setId,
			isNetworkAvailable.value,
			pickBy({ isOfflineData: offlineParams.value ? true : false }),
		)
			.then(async (response: object) => { 
				safetyFactorOptions.value = response.data.status;
				questions.value = response.data.questions;
				riskCodes.value = response.data.riskCodes;
				form.value = CaseSafetyAssessmentForm.updateAutoFill(response.data.item);
				form.value = CaseSafetyAssessmentForm.updateForm(response.data.item); 
				template(response.data.item.safety_assessment_questions); 
                await syncToOffline();
				loaded.value = true; 
			})
			.catch((error: object) => console.log(error));
	} else {
		await CaseImmediateService.create(
			patientId.value,
			caseId.value,
			isNetworkAvailable.value,
			pickBy({ isOfflineData: offlineParams.value ? true : false }),
		)
			.then(async (response: any) => {
				if (isNetworkAvailable.value) {
					safetyFactorOptions.value = response.data.status;
					questions.value = response.data.questions;
					riskCodes.value = response.data.riskCodes;
					form.value = CaseSafetyAssessmentForm.updateAutoFill(response.data.case);
					form.value.questions = questions.value;
				} else {
					safetyFactorOptions.value = response.data.status;
					questions.value = response.data.questions;
					riskCodes.value = response.data.riskCodes;
					form.value = CaseSafetyAssessmentForm.updateAutoFill(response.data.case);
					form.value.questions = questions.value;
				}
                template(form.value.questions)
                loaded.value = true; 
			})
			.catch((error: any) => console.log(error));
	}
};
 
const syncToOffline = async () => {
    if (isNetworkAvailable.value) {
        await AssessmentOfflineProcessor.syncToOffline(caseId.value, form.value);
    }
}

watch([() => form.value.questions], (val: object) => { 
	form.value.yes_count = renderCount(val[0] ?? [], SafetyAssessmentStatus.YES);
	form.value.no_count = renderCount(val[0] ?? [], SafetyAssessmentStatus.NO);
	form.value.unknown_count = renderCount(val[0] ?? [], SafetyAssessmentStatus.UNKNOWN);
},{deep:true});

onIonViewWillEnter(async () => { 
    // await checkIfAssessmentIsCreated();
    await getData()     
}); 

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit${offlineParams.value ? '?offline=true' : ''}`,
    hasBackClass: "flex md:justify-between md:items-center md:flex-row flex-col"
  }, {
    lowerRight: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
						_unref(router).replace(
							`/patient/${patientId.value}/cases/${caseId.value}/edit${offlineParams.value ? '?offline=true' : ''}`
						)
					)),
          class: "md:w-auto w-full md:mt-0 mt-6"
        }, [
          _createVNode(ButtonComponent, {
            btnWidth: "quinary",
            customClass: "quinary md:w-auto w-full"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          })
        ]),
        _createVNode(ButtonComponent, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (validateForm())),
          customClass: "primary md:w-auto w-full md:mt-0 mt-6"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode("Patient's Name: "),
        _createElementVNode("span", _hoisted_4, _toDisplayString(`${form.value.last_name}, ${form.value.first_name}`), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(SectionTitle, { title: "Immediate Safety Assessment\t" })
        ]),
        (loaded.value)
          ? (_openBlock(), _createElementBlock("form", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "text",
                  label: "Case Number",
                  placeholder: "Case Number",
                  name: "case_number",
                  id: "case_number",
                  modelValue: form.value.case_number,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.case_number) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(DatePicker, {
                  disabled: true,
                  id: "assessment_date",
                  name: "date_initiated",
                  label: "Date Initiated",
                  modelValue: form.value.assessment_date,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.assessment_date) = $event)),
                  error: errors.value?.assessment_date,
                  "max-date": new Date()
                }, null, 8, ["modelValue", "error", "max-date"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Last Name",
                  placeholder: "Last name",
                  name: "last_name",
                  id: "last_name",
                  disabled: true,
                  required: "",
                  modelValue: form.value.last_name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.last_name) = $event)),
                  error: errors.value?.last_name
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "text",
                  label: "First Name",
                  placeholder: "First name",
                  name: "first_name",
                  id: "first_name",
                  required: "",
                  modelValue: form.value.first_name,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.first_name) = $event)),
                  error: errors.value?.first_name
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "text",
                  label: "Middle Name",
                  placeholder: "Middle name",
                  name: "middle_name",
                  id: "middle_name",
                  modelValue: form.value.middle_name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.middle_name) = $event)),
                  error: errors.value?.middle_name
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(CheckboxInput, {
                  checked: form.value.is_assessment_patient_sibling,
                  id: "is_assessment_patient_sibling",
                  name: "assessment_sibling",
                  label: "Assessment is for patient's sibling",
                  modelValue: form.value.is_assessment_patient_sibling,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.is_assessment_patient_sibling) = $event))
                }, null, 8, ["checked", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(TextInput, {
                  textarea: "",
                  label: "Appointments",
                  placeholder: "Appointments",
                  name: "appointments",
                  id: "appointment",
                  textAreaRows: 1,
                  modelValue: form.value.appointment,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.appointment) = $event)),
                  error: errors.value?.appointment
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: question }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, _toDisplayString(question.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(RadioGroup, {
                          options: safetyFactorOptions.value,
                          name: `caretaker_${index}`,
                          id: ``,
                          modelValue: form.value.questions[index]['status'],
                          "onUpdate:modelValue": ($event: any) => ((form.value.questions[index]['status']) = $event)
                        }, null, 8, ["options", "name", "modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(CkEditor, {
                        label: "Information supporting safety factor:",
                        modelValue: form.value.questions[index]['supporting_information'],
                        "onUpdate:modelValue": ($event: any) => ((form.value.questions[index]['supporting_information']) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ])
                  ], 64))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(CkEditor, {
                  label: "Brief Family Background",
                  modelValue: form.value.brief_family_background,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.brief_family_background) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(CkEditor, {
                  label: "Family Background",
                  modelValue: form.value.family_background,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.family_background) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _hoisted_25,
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "number",
                  label: "Total number of “Yes”",
                  placeholder: "#",
                  name: "number_yes",
                  id: "number_yes",
                  modelValue: form.value.yes_count,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.yes_count) = $event)),
                  error: errors.value?.yes_count
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "number",
                  label: "Total number of “No”",
                  placeholder: "#",
                  name: "number_no",
                  id: "number_no",
                  modelValue: form.value.no_count,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.no_count) = $event)),
                  error: errors.value?.no_count
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(TextInput, {
                  disabled: true,
                  type: "number",
                  label: "Total number of “Unknown”",
                  placeholder: "#",
                  name: "number_unknown",
                  id: "number_unknown",
                  modelValue: form.value.unknown_count,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.unknown_count) = $event)),
                  error: errors.value?.unknown_count
                }, null, 8, ["modelValue", "error"])
              ]),
              _hoisted_30,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(riskCodes.value, (riskCode) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-span-6",
                  key: riskCode
                }, [
                  _createElementVNode("label", _hoisted_31, [
                    _createVNode(RadioGroup, {
                      options: [{ id: riskCode.id, value: riskCode.id, label: '' }],
                      name: `caretaker_${_ctx.index}`,
                      modelValue: form.value.risk_code_id,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.risk_code_id) = $event))
                    }, null, 8, ["options", "name", "modelValue"]),
                    _createElementVNode("p", _hoisted_32, _toDisplayString(riskCode.description), 1)
                  ])
                ]))
              }), 128)),
              (errors.value?.risk_code_id)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["text-[10px] mt-1", errors.value?.risk_code_id ? 'text-red-600' : 'text-gray-800']),
                    id: "email-error"
                  }, _toDisplayString(errors.value?.risk_code_id), 3))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(CkEditor, {
                  label: "Immediate Safety Plan",
                  modelValue: form.value.immediate_safety_plan,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.immediate_safety_plan) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(CkEditor, {
                  label: "Rationale of Overall Immediate Safety Assessment",
                  modelValue: form.value.overall_risk_assessment,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.overall_risk_assessment) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[17] || (_cache[17] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Record Save!",
        content: successMessage.value
      }, null, 8, ["show", "content"])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})